import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

/* Layout */
import Layout from '@/layout';

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export var constantRoutes = [{
  path: '/login',
  component: function component() {
    return import('@/views/login/index');
  },
  hidden: true
}, {
  path: '/404',
  component: function component() {
    return import('@/views/404');
  },
  hidden: true
}, {
  path: '/',
  component: Layout,
  redirect: '/dashboard',
  children: [{
    path: 'dashboard',
    name: 'Dashboard',
    component: function component() {
      return import('@/views/dashboard/index');
    },
    meta: {
      title: '首页',
      icon: 'iconjiajutubiao_huaban'
    }
  }]
}

// 404 page must be placed at the end !!!
//{ path: '*', redirect: '/404', hidden: true }
];
export var asyncRouterMap = [{
  path: '/main',
  component: Layout,
  alwaysShow: true,
  redirect: 'noRedirect',
  // redirect: '/main/table',
  name: 'main',
  meta: {
    title: '首页管理',
    icon: 'iconhome'
  },
  children: [{
    path: 'promotion',
    name: 'promotion',
    component: function component() {
      return import('@/views/main/index');
    },
    meta: {
      title: '广告轮播',
      icon: 'iconguanggaoshezhi'
    }
  }]
}, {
  path: '/resource',
  component: Layout,
  redirect: 'noRedirect',
  isAdmin: true,
  meta: {
    title: '资源管理',
    icon: 'iconresources'
  },
  children: [{
    path: 'public',
    name: 'public',
    component: function component() {
      return import('@/views/resource/public');
    },
    meta: {
      title: '上报资源管理',
      icon: 'iconnavicon-hzsb'
    }
  }, {
    path: 'private',
    name: 'private',
    isAdmin: true,
    component: function component() {
      return import('@/views/resource/private');
    },
    meta: {
      title: '总资源管理',
      icon: 'iconresources'
    }
  }, {
    path: 'textbook',
    name: 'textbook',
    isAdmin: true,
    component: function component() {
      return import('@/views/resource/textbook');
    },
    meta: {
      title: '教材目录管理',
      icon: 'iconjiaocai'
    }
  }, {
    path: 'public/pubdetail/:id',
    name: 'pubdetail',
    hidden: true,
    component: function component() {
      return import('@/views/resource/pubdetail');
    },
    meta: {
      title: '资源详情页',
      icon: 'point',
      parent_Path: '/resource/public'
    }
  }, {
    path: 'public/pubedit/:id',
    name: 'pubedit',
    hidden: true,
    component: function component() {
      return import('@/views/resource/pubedit');
    },
    meta: {
      title: '编辑资源',
      icon: 'point',
      parent_Path: '/resource/public'
    }
  }, {
    path: 'private/detail/:id',
    name: 'detail',
    hidden: true,
    component: function component() {
      return import('@/views/resource/detail');
    },
    meta: {
      title: '资源详情页',
      icon: 'point',
      parent_Path: '/resource/private'
    }
  }, {
    path: 'private/edit/:id',
    name: 'edit',
    hidden: true,
    component: function component() {
      return import('@/views/resource/edit');
    },
    meta: {
      title: '编辑资源',
      icon: 'point',
      parent_Path: '/resource/private'
    }
  }]
}, {
  path: '/resource',
  component: Layout,
  redirect: 'noRedirect',
  // redirect: '/main/table',
  name: 'resource',
  meta: {
    title: '资源管理',
    icon: 'iconresources'
  },
  children: [{
    path: 'type',
    name: 'type',
    component: function component() {
      return import('@/views/resource/type');
    },
    meta: {
      title: '资源类型',
      icon: 'icon17'
    }
  }, {
    path: 'curriculum',
    name: 'curriculum',
    component: function component() {
      return import('@/views/resource/curriculum');
    },
    meta: {
      title: '学科管理',
      icon: 'iconxuexiao_kemu'
    }
  }, {
    path: 'edition',
    name: 'edition',
    component: function component() {
      return import('@/views/resource/edition');
    },
    meta: {
      title: '版本管理',
      icon: 'iconbanben'
    }
  }, {
    path: 'grade',
    name: 'grade',
    component: function component() {
      return import('@/views/resource/grade');
    },
    meta: {
      title: '年级管理',
      icon: 'iconnianji'
    }
  }, {
    path: 'edition/tabcontent/:id',
    name: 'tabcontent',
    hidden: true,
    component: function component() {
      return import('@/views/resource/tabcontent');
    },
    meta: {
      title: '目录详情',
      icon: 'point',
      parent_Path: '/resource/grade'
    }
  }, {
    path: 'private',
    name: 'private',
    component: function component() {
      return import('@/views/resource/private');
    },
    meta: {
      title: '总资源管理',
      icon: 'iconresources'
    }
  }, {
    path: 'private/detail/:id',
    name: 'detail',
    hidden: true,
    component: function component() {
      return import('@/views/resource/detail');
    },
    meta: {
      title: '资源详情页',
      icon: 'point',
      parent_Path: '/resource/private'
    }
  }, {
    path: 'private/edit/:id',
    name: 'edit',
    hidden: true,
    component: function component() {
      return import('@/views/resource/edit');
    },
    meta: {
      title: '编辑资源',
      icon: 'point',
      parent_Path: '/resource/private'
    }
  }, {
    path: 'public',
    name: 'public',
    isAdmin: true,
    component: function component() {
      return import('@/views/resource/public');
    },
    meta: {
      title: '上报资源管理',
      icon: 'iconnavicon-hzsb'
    }
  }, {
    path: 'textbook',
    name: 'textbook',
    isAdmin: true,
    component: function component() {
      return import('@/views/resource/textbook');
    },
    meta: {
      title: '教材目录管理',
      icon: 'iconjiaocai'
    }
  }, {
    path: 'public/pubdetail/:id',
    name: 'pubdetail',
    hidden: true,
    component: function component() {
      return import('@/views/resource/pubdetail');
    },
    meta: {
      title: '资源详情页',
      icon: 'point',
      parent_Path: '/resource/public'
    }
  }, {
    path: 'public/pubedit/:id',
    name: 'pubedit',
    hidden: true,
    component: function component() {
      return import('@/views/resource/pubedit');
    },
    meta: {
      title: '编辑资源',
      icon: 'point',
      parent_Path: '/resource/public'
    }
  }, {
    path: 'advertise',
    name: 'advertise',
    component: function component() {
      return import('@/views/resource/advertise');
    },
    meta: {
      title: '广告位管理',
      icon: 'iconguanggaoshezhi'
    }
  }]
}, {
  path: '/studio',
  component: Layout,
  redirect: 'noRedirect',
  // redirect: '/main/table',
  name: 'studio',
  isStudioAdmin: true,
  meta: {
    title: '',
    icon: 'iconstudionew'
  },
  children: [{
    path: 'studioapply',
    name: 'studioapply',
    isStudioAdmin: true,
    component: function component() {
      return import('@/views/studio/studioapply');
    },
    meta: {
      title: '工作室申请审核',
      icon: 'iconstudionew'
    }
  }, {
    path: 'studioapply/detail/:id',
    name: 'studioapplydetail',
    isStudioAdmin: true,
    hidden: true,
    component: function component() {
      return import('@/views/studio/studioapplydetail');
    },
    meta: {
      title: '工作室申请审核详情',
      icon: 'point',
      activeMenu: "/studio/studioapply"
    }
  }]
}, {
  path: '/community',
  component: Layout,
  redirect: 'noRedirect',
  // redirect: '/main/table',
  name: 'community',
  meta: {
    title: '社区管理',
    icon: 'iconshequ'
  },
  children: [{
    path: 'post',
    name: 'post',
    component: function component() {
      return import('@/views/community/post');
    },
    meta: {
      title: '帖子管理',
      icon: 'iconnews_icon'
    }
  }, {
    path: 'post/postdetail/:id',
    name: 'postdetail',
    hidden: true,
    component: function component() {
      return import('@/views/community/postdetail');
    },
    meta: {
      title: '帖子详情',
      icon: 'iconxuexiao_kemu',
      parent_Path: '/community/post'
    }
  }, {
    path: 'question',
    name: 'question',
    component: function component() {
      return import('@/views/community/question');
    },
    meta: {
      title: '问答管理',
      icon: 'iconwenda1'
    }
  }, {
    path: 'question/questiondetail/:id',
    name: 'questiondetail',
    hidden: true,
    component: function component() {
      return import('@/views/community/questiondetail');
    },
    meta: {
      title: '问答详情',
      icon: 'point',
      parent_Path: '/community/question'
    }
  }, {
    path: 'uchoice',
    name: 'uchoice',
    component: function component() {
      return import('@/views/community/uchoice');
    },
    meta: {
      title: '优选参数设置',
      icon: 'iconking'
    }
  }, {
    path: 'tag',
    name: 'tag',
    hidden: true,
    component: function component() {
      return import('@/views/community/tag');
    },
    meta: {
      title: '标签管理',
      icon: 'point'
    }
  }]
}, {
  path: '/news',
  component: Layout,
  redirect: 'noRedirect',
  // redirect: '/main/table',
  name: 'news',
  meta: {
    title: '新闻管理',
    icon: 'iconnews_icon'
  },
  children: [{
    path: 'news',
    name: 'news',
    component: function component() {
      return import('@/views/news/news');
    },
    meta: {
      title: '新闻管理',
      icon: 'iconnews_icon'
    }
  }, {
    path: 'news/news_addeditdetail',
    name: 'news_addeditdetail',
    hidden: true,
    component: function component() {
      return import('@/views/news/news_addeditdetail');
    },
    meta: {
      title: '新闻管理详情',
      icon: 'point',
      activeMenu: "/news/news"
    }
  }]
}, {
  path: '/user',
  component: Layout,
  redirect: 'noRedirect',
  // redirect: '/main/table',
  name: 'user',
  meta: {
    title: '用户管理',
    icon: 'iconyonghuguanli'
  },
  children: [{
    path: 'front',
    name: 'front',
    component: function component() {
      return import('@/views/user/front');
    },
    meta: {
      title: '平台用户管理',
      icon: 'iconhoutaiguanli'
    }
  }, {
    path: 'back',
    name: 'back',
    component: function component() {
      return import('@/views/user/back');
    },
    meta: {
      title: '后台用户管理',
      icon: 'iconuserlist'
    }
  }, {
    path: 'complaint',
    name: 'complaint',
    component: function component() {
      return import('@/views/user/complaint');
    },
    meta: {
      title: '举报审核',
      icon: 'iconnavicon-hzsb'
    }
  }]
}, {
  path: '/system',
  component: Layout,
  redirect: 'noRedirect',
  // redirect: '/main/table',
  name: 'system',
  meta: {
    title: '系统管理',
    icon: 'iconxitong'
  },
  children: [{
    path: 'platform',
    name: 'platform',
    component: function component() {
      return import('@/views/system/platform');
    },
    meta: {
      title: '平台信息管理',
      icon: 'iconhoutaiguanli'
    }
  }, {
    path: 'log',
    name: 'log',
    component: function component() {
      return import('@/views/system/log');
    },
    meta: {
      title: '操作日志',
      icon: 'iconnianji'
    }
  }]
},
// 404 page must be placed at the end !!!
{
  path: '*',
  redirect: '/404',
  hidden: true
}];
var createRouter = function createRouter() {
  return new Router({
    mode: 'history',
    // require service support
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;